import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { intlShape } from 'react-intl';
import * as logger from 'universal-logger';
import config from 'universal-config';
import { userProfile } from 'redux/saga/entities/bound';
import { load as loadScript } from 'helpers/scripts';
import { ga } from 'helpers/multitrack';
import { interpolate } from 'helpers/interpolate';
export var getFriendbuyApi = function getFriendbuyApi() {
  return __TEST__ ? global.testFriendbuy : window.friendbuy = window.friendbuy || [];
};
export var getFriendbuyScript = function getFriendbuyScript(countryCode) {
  if (countryCode === 'PHL') {
    return config().friendbuy.PHL.scriptUrl;
  }

  return config().friendbuy.default.scriptUrl;
};
export var getFriendbuySiteId = function getFriendbuySiteId(countryCode) {
  if (countryCode === 'PHL') {
    return config().friendbuy.PHL.siteId;
  }

  return config().friendbuy.default.siteId;
};
export function extractRafRewards(user) {
  var friendBuyInfo = user && user.friendbuy_info || {};
  var currencyFormat = friendBuyInfo.currency_format || '';
  var rafFallbackRewardAmount = friendBuyInfo.referral_reward > 0 ? friendBuyInfo.referral_reward : '';
  return {
    rafSenderReward: friendBuyInfo.sender_reward || "".concat(currencyFormat).concat(rafFallbackRewardAmount),
    rafReceiverReward: friendBuyInfo.receiver_reward || "".concat(currencyFormat).concat(rafFallbackRewardAmount)
  };
}
export var buildFriendbuyInterpolator = function buildFriendbuyInterpolator(state) {
  return function (str) {
    var profile = userProfile.data(state) || {};

    var _extractRafRewards = extractRafRewards(profile),
        rafSenderReward = _extractRafRewards.rafSenderReward,
        rafReceiverReward = _extractRafRewards.rafReceiverReward;

    return interpolate(str, {
      $FIRST_NAME: profile.first_name,
      $FRIENDBUY_REWARD: rafSenderReward,
      $SENDER_FIRST_NAME: profile.first_name,
      $SENDER_REWARD: rafSenderReward,
      $RECEIVER_REWARD: rafReceiverReward
    });
  };
};
export var FriendbuyWidget =
/*#__PURE__*/
function (_Component) {
  _inherits(FriendbuyWidget, _Component);

  function FriendbuyWidget() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FriendbuyWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FriendbuyWidget)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleWidgetClose", function (_ref) {
      var groupId = _ref.groupId,
          guid = _ref.guid;
      // Tinker with friendbuy's internal state so we can re-open the widget
      var friendbuy = getFriendbuyApi();

      if (friendbuy.widgets) {
        delete friendbuy.widgets[guid];
      }

      if (friendbuy.widgetPlacements) {
        Object.keys(friendbuy.widgetPlacements).forEach(function (name) {
          if (name.indexOf(groupId) === 0) {
            delete friendbuy.widgetPlacements[name];
          }
        });
      }

      var onClose = _this.props.onClose;

      if (onClose) {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleShareSuccess", function () {
      return ga('Refer-a-Friend', 'raf-successfully-sent', window.location.pathname, 0);
    });

    return _this;
  }

  _createClass(FriendbuyWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          email = _this$props.email,
          intl = _this$props.intl,
          userId = _this$props.userId,
          countryCode = _this$props.countryCode,
          widgetCode = _this$props.widgetCode;

      if (!widgetCode) {
        logger.warn("FriendbuyWidget initiated without a widgetCode for user ".concat(userId, "."));
        return;
      }

      if (!__TEST__ && !window.friendbuy) {
        loadScript(getFriendbuyScript(countryCode));
      }

      var friendbuy = getFriendbuyApi();
      friendbuy.push(['site', getFriendbuySiteId(countryCode)]);
      friendbuy.push(['track', 'customer', {
        id: String(userId),
        email: email,
        locale: intl.locale
      }]);
      friendbuy.push(['widget', widgetCode, {
        configuration: {
          share_button: false
        }
      }]);
      friendbuy.push(['subscribe', 'share.success', this.handleShareSuccess]);
      friendbuy.push(['subscribe', 'widget.close', this.handleWidgetClose]);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "text--center friendbuy-".concat(this.props.widgetCode)
      });
    }
  }]);

  return FriendbuyWidget;
}(Component);
FriendbuyWidget.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  intl: intlShape,
  userId: PropTypes.number.isRequired,
  countryCode: PropTypes.string.isRequired,
  widgetCode: PropTypes.string.isRequired
};